/* Porte Alliance — modules premium (21/10/2026) : valeur choisie des variantes, aperçu de la
   personnalisation, dates de livraison indicatives. Écouteurs délégués : compatible avec le
   chargement des pages sans rechargement (InstantClick) et avec les champs injectés par l'app. */
(function () {
  if (window.__paPremium) return; window.__paPremium = true;

  function chosen(root) {
    (root || document).querySelectorAll('.pa-sw').forEach(function (sw) {
      var c = sw.querySelector('input[type=radio]:checked');
      var out = sw.querySelector('.pa-sw__chosen');
      if (out) out.textContent = c ? c.value : '';
    });
  }

  function previewFor(form) {
    if (!form) return;
    var px = form.querySelector('.pa-px[data-perso="1"]');
    if (!px) return;
    var box = px.querySelector('.pa-preview'), lines = px.querySelector('.pa-preview__lines');
    var vals = [];
    form.querySelectorAll('input[name^="ymq["], textarea[name^="ymq["]').forEach(function (el) {
      if (el.type === 'hidden' || el.type === 'checkbox' || el.type === 'radio' || el.type === 'file') return;
      var v = (el.value || '').trim(); if (v) vals.push(v.slice(0, 80));
    });
    lines.innerHTML = '';
    vals.slice(0, 3).forEach(function (v) {
      var s = document.createElement('span'); s.className = 'pa-preview__l'; s.textContent = v; lines.appendChild(s);
    });
    box.hidden = vals.length === 0;
  }

  function dates() {
    var fmt = function (d) { return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' }); };
    document.querySelectorAll('.pa-ship').forEach(function (el) {
      var d1 = el.querySelector('[data-pa-d1]'), d2 = el.querySelector('[data-pa-d2]'), wrap = el.querySelector('.pa-ship__dates');
      if (!d1 || !d2 || !wrap) return;
      var a = new Date(), b = new Date(); a.setDate(a.getDate() + 3); b.setDate(b.getDate() + 12);
      d1.textContent = fmt(a); d2.textContent = fmt(b); wrap.hidden = false;
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.pa-sw')) chosen(e.target.closest('.pa-sw').parentNode);
  });
  document.addEventListener('input', function (e) {
    var t = e.target; if (t && t.name && t.name.indexOf('ymq[') === 0) previewFor(t.closest('form'));
  });

  function a11y() {
    document.querySelectorAll('input[name^="ymq["]:not([aria-label]), textarea[name^="ymq["]:not([aria-label])').forEach(function (el) {
      var m = el.name.match(/^ymq\[(.*)\]$/); if (m && m[1]) el.setAttribute('aria-label', m[1]);
    });
    document.querySelectorAll('input[id^="bvx-hero-q"]:not([aria-label])').forEach(function (el) { el.setAttribute('aria-label', 'Rechercher un produit'); });
  }
  if (window.MutationObserver) new MutationObserver(function () { if (a11y.q) return; a11y.q = setTimeout(function () { a11y.q = 0; a11y(); }, 300); }).observe(document.documentElement, { childList: true, subtree: true });

  function init() { a11y(); chosen(); dates(); document.querySelectorAll('form.shopify-product-form').forEach(previewFor); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('page:load', init);
  window.addEventListener('pageshow', init);
})();
